const TermsOfUse = {
  seo: {
    title: 'Terms of Service',
  },

  title: 'Terms of Service',
};

export default TermsOfUse;
